const accessData = [
  { id: 1, val: "Client", text: "Full Access" },
  { id: 2, val: "remediation-mode", text: "Remediation Mode" },
];

const accessRole = [
  { id: 1, val: "edit", text: "Edit" },
  { id: 2, val: "view", text: "View" },
];

export { accessData, accessRole };
